let toggle: HTMLElement | null;
let content: HTMLElement | null;
let contentInner: HTMLElement | null;

function init(container: HTMLElement | Document = document) {
    const accordions = container.querySelectorAll('[data-accordion]');

    accordions.forEach(accordion => {
        toggle = accordion.querySelector('[data-accordion-toggle]');
        content = accordion.querySelector('[data-accordion-content]');
        contentInner = accordion.querySelector('[data-accordion-content-inner]');

        if (content) {
            if (toggle && !toggle.classList.contains('is-show')) content.style.height = '0px';
            toggle?.addEventListener('click', onClick);
        }

        if (content && accordion.classList.contains('js-accordion-mobile')) {
            if (window.matchMedia('(min-width: 651px)').matches) {
                const height = `${contentInner?.scrollHeight}px`;
                content.style.height = height;
                accordion.removeAttribute('data-accordion');
                content?.removeAttribute('data-accordion-content');
            }
        }
    })
}

function onClick(this: HTMLElement) {

    const accordion = this.closest('[data-accordion]');
    const content = accordion?.querySelector<HTMLElement>('[data-accordion-content]');
    const contentInner = accordion?.querySelector<HTMLElement>('[data-accordion-content-inner]');
    this?.classList.toggle('is-show');

    if (content) {
        const accordionParentContnet: HTMLElement | null | undefined = accordion?.closest('[data-accordion-content]');
        const accordionParentInner: HTMLElement | null | undefined = accordion?.closest('[data-accordion-content-inner]');
        if (this && this.classList.contains('is-show')) {
            const height = `${contentInner?.scrollHeight}px`;
            content.style.height = height;

            if (accordionParentContnet && accordionParentInner) {
                accordionParentContnet.style.height = 'auto';
            }
        } else {
            content.style.height = '0px';
            const button = this.querySelector<HTMLButtonElement>('.js-accordion-button');
            if (button) button.blur();

            if (accordionParentContnet && accordionParentInner) {
                setTimeout(() => {
                    const heightParent = `${accordionParentInner?.scrollHeight}px`;
                    accordionParentContnet.style.height = heightParent;
                }, 500);
            }
        }
    }
}

function destroy(container: HTMLElement | Document = document) {
    Array.from(container.querySelectorAll<HTMLElement>('[data-accordion-toggle]')).forEach((el) => {
        el?.removeEventListener('click', onClick);
    });
}

const _module = { init, destroy };

export default _module;
